/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetVersionPolicy200ResponseIos
 */
export interface GetVersionPolicy200ResponseIos {
    /**
     * 
     * @type {string}
     * @memberof GetVersionPolicy200ResponseIos
     */
    warningVersion: string;
    /**
     * 
     * @type {string}
     * @memberof GetVersionPolicy200ResponseIos
     */
    deprecatedVersion: string;
}

/**
 * Check if a given object implements the GetVersionPolicy200ResponseIos interface.
 */
export function instanceOfGetVersionPolicy200ResponseIos(value: object): value is GetVersionPolicy200ResponseIos {
    if (!('warningVersion' in value) || value['warningVersion'] === undefined) return false;
    if (!('deprecatedVersion' in value) || value['deprecatedVersion'] === undefined) return false;
    return true;
}

export function GetVersionPolicy200ResponseIosFromJSON(json: any): GetVersionPolicy200ResponseIos {
    return GetVersionPolicy200ResponseIosFromJSONTyped(json, false);
}

export function GetVersionPolicy200ResponseIosFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetVersionPolicy200ResponseIos {
    if (json == null) {
        return json;
    }
    return {
        
        'warningVersion': json['warningVersion'],
        'deprecatedVersion': json['deprecatedVersion'],
    };
}

export function GetVersionPolicy200ResponseIosToJSON(json: any): GetVersionPolicy200ResponseIos {
    return GetVersionPolicy200ResponseIosToJSONTyped(json, false);
}

export function GetVersionPolicy200ResponseIosToJSONTyped(value?: GetVersionPolicy200ResponseIos | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warningVersion': value['warningVersion'],
        'deprecatedVersion': value['deprecatedVersion'],
    };
}

